import axios from 'axios'  
var $http = axios;
const URL_GET_USER_INFO = '/api/mobile/user/personCenter';
//发送请求
export function getUserInfo(){
  return $http.get(URL_GET_USER_INFO).then(res => {
    // console.log(res.data.user.userName);
    // res.data.user.isAdmin = 1;
    // console.log(res);
    localStorage.setItem("userInfo", JSON.stringify(res.data.user));
    localStorage.setItem("yearTerm", JSON.stringify(res.data.nowYearAndTermAndMonth));
    return res.data;
  });
}

const URL_GET_YEARTERM = '/api/mobile/user/getSchoolNowYearAndTermAndMonth';
//发送请求
export function getYearTerm(){
  return $http.get(URL_GET_YEARTERM).then(res => {
      return res.data;
  });
}


// WEBPACK FOOTER //
// ./src/service/user-service.js